<template>
  <div class="container">
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>
      </div>
      <el-button size="small" type="success" @click="export2Excel()">导出excel</el-button>
    </div>
    <div style="padding-bottom: 20px">

      <!--      <el-select v-model="curTimeRange" clearable @change="curSelectOptionChange()">-->
      <!--        <el-option v-for="item in timeRangeOption" :value="item.value" :key="item.value"-->
      <!--                   :label="item.label"></el-option>-->
      <!--      </el-select>-->

      <el-date-picker v-model="searchDateRange" type="daterange" editable :clearable="false"
                      range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间"
                      value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" unlink-panels
                      :picker-options="pickerOptions"
                      @change="search()"/>
    </div>


    <!-- 内容 -->
    <el-table ref="allUserList" v-loading="loading" :data="tableData"
              :header-cell-style="{ background: '#F5F7FA' }" style="width: 100%; margin-bottom: 20px" border>
      <el-table-column prop="userLoginId" label="#" align="center" width="150"></el-table-column>
      <el-table-column prop="userId" label="用户ID" align="center" width="150"></el-table-column>
      <el-table-column align="center" label="用户" width="200">
        <template #default="scope">
          <UserInfo :user="scope.row"></UserInfo>
        </template>
      </el-table-column>
      <el-table-column prop="terminalType" label="终端类型" align="center" width="200">
        <template #default="scope">
          {{ scope.row.terminalType | terminalTypeTransform }}
        </template>
      </el-table-column>
      <el-table-column prop="ip" label="ip" align="center" width="200"/>
      <el-table-column prop="ipDetails" label="ip详情" align="center"/>
      <el-table-column prop="loginTime" label="登录时间" align="center" width="200">
        <template #default="scope">
          {{ scope.row.loginTime | formatDateTime }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination background :total="pageOpt.totalCount" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.currentPage" @current-change="currentPageChange"/>

  </div>
</template>

<script>
import {getUserLoginList} from "@/api/statisticsManagement/statisticalData";
import {handleRes, handleResWithReturn} from "@/utils/handleRes";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";
import {addDateTime, DateShortCut, DateTimeField, getTimeFromString} from "@/utils/DateUtils";
import {isVaild} from "@/utils/validate";
import {printObj} from "@/utils/debug";
import UserInfo from "@/components/UserInfo/UserInfo";
import {export_json_to_excel} from "@/vendor/Export2Excel";
import {getDisplayName} from "@/utils/userutil";

export default {
  name: "UserLoginInfo",
  components: {UserInfo},
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.pageOpt.currentPage = navigationObj.currentPage ?? 1
    this.searchValue = navigationObj.searchValue
    let endTime = getTimeFromString(`${new Date().format("yyyy-MM-dd")} 23:59:59`)
    // endTime 09-09，做一次减三个月运算后，为06-09，需加1s才是三个月内
    // 而且因后面选择时间格式为xxx 00:00:00，这里兼容后面统一处理加1s，否则这里是06-09 23:59:59，界面显示06-09，数据又是06-10，加1s显示为06-10
    this.searchDateRange[0] = new Date(addDateTime(addDateTime(endTime, DateTimeField.Month, -3), DateTimeField.Second, 1)).format("yyyy-MM-dd HH:mm:ss");
    this.searchDateRange[1] = new Date(endTime).format("yyyy-MM-dd HH:mm:ss");
    if (isVaild(navigationObj.searchDateRange)) {
      this.searchDateRange = navigationObj.searchDateRange
    }
    this.curTimeRange = navigationObj.timeRange ?? 0

    this.refreshList();
  },
  data() {
    return {
      navigationKey: "StatisticsUserLoginInfo",
      //获取的数据时间范围 0-三个月之内 1-一年之内 2- 三年之内 3- 所有 默认0
      timeRangeOption: [
        {value: 0, label: "三个月之内"},
        {value: 1, label: "一年之内"},
        {value: 2, label: "三年之内"},
        {value: 3, label: "所有"},
      ],
      curTimeRange: 0,
      pickerOptions: {
        // 时间不能大于当前时间
        disabledDate: time => {
          let nowDateTime = getTimeFromString(`${new Date().format('yyyy-MM-dd')} 23:59:59`)
          // return time.getTime() > Date.now() || time.getTime() < this.getStartTimeFromNow()
          let startTime = addDateTime(nowDateTime, DateTimeField.Month, -3)
          return time.getTime() > Date.now() || time.getTime() < startTime;
        },
        shortcuts: [
          {
            text: '一周内',
            onClick: (picker) => {
              this.shortCutPickDate(picker, DateShortCut.Week)
            },
          },
          {
            text: '一个月内',
            onClick: (picker) => {
              this.shortCutPickDate(picker, DateShortCut.Month)
            },
          },
          {
            text: '三个月内',
            onClick: (picker) => {
              this.shortCutPickDate(picker, DateShortCut.ThreeMonth)
            },
          },
        ]
      },
      searchDateRange: [],
      searchValue: "",
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      tableData: [],
      loading: false
    }
  },
  methods: {
    /**
     * 快捷选择日期范围，一周/一个月/三个月
     * @param picker
     * @param type
     */
    shortCutPickDate(picker, type) {
      const endTime = getTimeFromString(`${new Date().format("yyyy-MM-dd")} 23:59:59`)
      const startDate = new Date()
      switch (type) {
        case DateShortCut.Week:
          startDate.setTime(addDateTime(endTime, DateTimeField.Day, -7))
          break
        case DateShortCut.Month:
          startDate.setTime(addDateTime(endTime, DateTimeField.Month, -1))
          break
        case DateShortCut.ThreeMonth:
          startDate.setTime(addDateTime(endTime, DateTimeField.Month, -3))
          break
      }
      startDate.setTime(addDateTime(startDate, DateTimeField.Second, 1))
      // this.searchDateRange[0] = startDate.format("yyyy-MM-dd HH:mm:ss");
      // this.searchDateRange[1] = new Date(endTime).format("yyyy-MM-dd HH:mm:ss");
      picker.$emit('pick', [startDate, new Date(endTime)])
      // this.$forceUpdate()
      this.refreshList();
    },
    /**
     * 搜索
     */
    search() {
      this.pageOpt.currentPage = 1
      this.refreshList()
    },
    /**
     * 时间范围下拉框改变
     */
    curSelectOptionChange() {
      //this.refreshList()
      this.searchDateRange = null
    },
    /**
     * 翻页
     * @param page
     */
    currentPageChange(page) {
      this.pageOpt.currentPage = page
      this.refreshList()
    },
    /**
     * 获取数据后，绑定tableData
     * @returns {Promise<void>}
     */
    async refreshList() {
      let userLoginInfoResponse = await this.getUserLoginList();
      if (isVaild(userLoginInfoResponse)) {
        this.tableData = userLoginInfoResponse.rows
        this.pageOpt.totalCount = userLoginInfoResponse.total
      }
    },
    /**
     * 根据开始时间，转换timeRange
     * @returns {number}
     */
    transformTimeRange() {
      let nowTime = getTimeFromString(`${new Date().format("yyyy-MM-dd")} 23:59:59`)
      let startTime = getTimeFromString(this.searchDateRange[0]);

      if (startTime <= addDateTime(nowTime, DateTimeField.Year, -3)) {
        // console.log('所有')
        this.curTimeRange = 3
      } else if (startTime <= addDateTime(nowTime, DateTimeField.Year, -1)) {
        // console.log('三年内')
        this.curTimeRange = 2
      } else if (startTime <= addDateTime(nowTime, DateTimeField.Month, -3)) {
        // console.log('一年内')
        this.curTimeRange = 1
      } else {
        // console.log('三月内')
        this.curTimeRange = 0;
      }
    },
    /**
     * 调用接口，获取数据
     * @param pageSize
     * @param pageNumber
     * @returns {Promise<null|*>}
     */
    async getUserLoginList(pageSize = this.pageOpt.pageSize, pageNumber = this.pageOpt.currentPage) {
      let param = {
        pageNumber: pageNumber,
        pageSize: pageSize,
        keyWord: this.searchValue,
        timeRange: this.curTimeRange
      }
      //开始时间、结束时间，转换成毫秒
      if (isVaild(this.searchDateRange) && isVaild(this.searchDateRange.length > 2)) {
        // console.log(`startTime ${this.searchDateRange[0]}`)
        // console.log(`endTime ${this.searchDateRange[1]}`)
        param.startTime = getTimeFromString(this.searchDateRange[0])
        param.endTime = getTimeFromString(`${new Date(this.searchDateRange[1]).format("yyyy-MM-dd")} 23:59:59`)
      }
      //自动转换timeRange
      if (param.startTime) {
        this.transformTimeRange()
        param.timeRange = this.curTimeRange
      }
      setNavigationItemWithObj(this.navigationKey, {
        currentPage: this.pageOpt.currentPage,
        searchValue: this.searchValue,
        searchDateRange: this.searchDateRange,
        timeRange: this.curTimeRange
      })
      // console.log(`getUserLoginList`)
      // printObj(param)
      this.loading = true
      let res = await getUserLoginList(param)
      this.loading = false;
      // console.log(`getUserLoginList ${this.pageOpt.currentPage}`)
      if (handleResWithReturn(res)) {
        return res.data
      }
      return null;
    },
    /**
     * 根据当前条件，导出数据（不分页）到excel
     * @returns {Promise<void>}
     */
    async export2Excel() {
      let allUserLoginInfoResponse = await this.getUserLoginList(0, 1)
      if (isVaild(allUserLoginInfoResponse)) {
        let exportData = allUserLoginInfoResponse.rows
        if (exportData.length === 0) {
          this.$message.info('没有要导出数据')
          return;
        }
        let {
          tName,
          tHeader,
          filterValue
        } = this.getExcelInfo()
        let list = this.formatChatInfoTable(allUserLoginInfoResponse.rows)
        let data = this.formatJson(filterValue, list)
        export_json_to_excel({
          header: tHeader,
          data,
          filename: tName,
          autoWidth: true,
          bookType: "xlsx",
        })
      }

    },
    getExcelInfo() {
      let tName = '用户登录统计数据';
      let tHeader;
      let filterValue;
      tHeader = ['#', '用户ID', '用户', '终端类型', 'ip', 'ip详情', '登录时间']
      filterValue = [
        'userLoginId',
        'userId',
        'nickname',
        'terminalType',
        'ip',
        'ipDetails',
        'loginTime',
      ]
      return {
        tName,
        tHeader,
        filterValue
      }
    },
    /**
     * 格式化 JSON
     *
     * @param filterValue
     * @param jsonData
     */
    formatJson(filterValue, jsonData) {
      return jsonData.map(x => filterValue.map(y => {
        return x[y]
      }))
    },
    /**
     * 格式化 userInfoTable
     *
     * @param list
     */
    formatChatInfoTable(list) {
      let newList = list.map(item => {
        item.loginTime = this.$options.filters["formatDateTime"](item.loginTime)
        item.terminalType = this.$options.filters["terminalTypeTransform"](item.terminalType)
        item.nickname = getDisplayName(item)
        return item
      })

      return newList
    },

  }
}
</script>

<style scoped>

</style>